const rng = (seed) => () => {
  seed |= 0; seed = (seed + 0x6d2b79f5) | 0;
  let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

export const buildTree = (seed = 1890) => {
  const r = rng(seed);
  const branches = [];
  const leaves = [];
  const MAX = 7;
  const grow = (x, y, ang, len, depth, width) => {
    const ex = x + Math.cos(ang) * len;
    const ey = y + Math.sin(ang) * len;
    const bend = (r() - 0.5) * len * 0.35;
    const cx = (x + ex) / 2 + Math.cos(ang + Math.PI / 2) * bend;
    const cy = (y + ey) / 2 + Math.sin(ang + Math.PI / 2) * bend;
    branches.push({ d: `M${x.toFixed(1)} ${y.toFixed(1)} Q${cx.toFixed(1)} ${cy.toFixed(1)} ${ex.toFixed(1)} ${ey.toFixed(1)}`, depth, width, start: 0.04 + depth * 0.105 });
    if (depth >= MAX) {
      for (let i = 0; i < 2; i++) leaves.push({ x: ex + (r() - 0.5) * 26, y: ey + (r() - 0.5) * 26, rot: r() * 360, s: 0.7 + r() * 0.7, t: 0.62 + r() * 0.34 });
      return;
    }
    const kids = depth < 2 ? 2 : r() > 0.35 ? 2 : 3;
    for (let k = 0; k < kids; k++) {
      const spread = (depth < 2 ? 0.45 : 0.55) + r() * 0.25;
      const a = ang + (k - (kids - 1) / 2) * spread + (r() - 0.5) * 0.2;
      grow(ex, ey, a, len * (0.7 + r() * 0.1), depth + 1, width * 0.68);
    }
    if (depth > 3 && r() > 0.5) leaves.push({ x: ex, y: ey, rot: r() * 360, s: 0.6 + r() * 0.5, t: 0.55 + r() * 0.35 });
  };
  grow(500, 760, -Math.PI / 2, 150, 0, 22);
  const roots = [];
  for (let i = 0; i < 7; i++) {
    const a = Math.PI / 2 + (i - 3) * 0.32;
    const len = 60 + r() * 70;
    roots.push(`M500 760 Q${(500 + Math.cos(a) * len * 0.6 + (r() - 0.5) * 30).toFixed(1)} ${(760 + Math.sin(a) * len * 0.4).toFixed(1)} ${(500 + Math.cos(a) * len).toFixed(1)} ${(760 + Math.sin(a) * len * 0.55).toFixed(1)}`);
  }
  return { branches, leaves, roots };
};
